import LoadingBars from "./LoadingBars";
import NormalText from "./NormalText";
import Price from "./Price";
import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  getCoverIdForInsurerResponse,
  getCoverIdOfPrice,
} from "../store/businesslogic/hardwiredlogic";
import {
  PossibleCoverValues,
  PossibleExcelApiStatusValues,
} from "../store/helperfuncs";
import LaunchIcon from "@material-ui/icons/Launch";
import { changeHelpOrTipText } from "../store/components";
import { useNavigate } from "react-router-dom";
import { getCovers, getExcelApiStatus } from "../store/quotes";
import WarningIcon from "@material-ui/icons/Warning";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";

export const PriceDeciderComp = (props) => {
  const { responseid } = props;
  const covers = useSelector(getCovers(responseid));
  const excelApiStatus = useSelector(getExcelApiStatus(responseid));
  let history = useNavigate();

  const dispatch = useDispatch();
  // possible value of excelAPIstatus to consider is loading, failed, success, not started

  if (excelApiStatus === PossibleExcelApiStatusValues.loading) {
    return (
      <LoadingBars
        type={"bars"}
        color={theme.COLORS.secondary_orange}
      ></LoadingBars>
    );
  }

  if (excelApiStatus === PossibleExcelApiStatusValues.failed) {
    return (
      <WarningIcon
        onMouseOver={() => {
          dispatch(
            changeHelpOrTipText(
              "Sorry, we had a technical error in retrieving this quote.  Please try again soon."
            )
          );
        }}
      ></WarningIcon>
    );
  }

  if (
    excelApiStatus === PossibleExcelApiStatusValues.success ||
    excelApiStatus === PossibleExcelApiStatusValues.notstarted
  ) {
    return (
      <PriceTextDecider
        responseid={responseid}
        priceObject={creatPriceObjectFromCover(covers)}
      ></PriceTextDecider>
    );
  }

  return (
    <LoadingBars
      type={"bars"}
      color={theme.COLORS.secondary_orange}
    ></LoadingBars>
  );
};

const creatPriceObjectFromCover = (covers) => {
  if (_.isEmpty(covers)) {
    return { value: null, reason: "EMPTY_COVERS" };
  }
  const price = covers[getCoverIdOfPrice()];

  let firstCover = covers[getCoverIdForInsurerResponse()];

  // if the price is Refere or decline or pending
  // TODO: this constants should be globalized and resused
  if (price === "Refer" || price === "Decline" || price === "Pending") {
    return { value: firstCover, reason: "MESSAGE" };
  }

  if (price === undefined) {
    return { value: null, reason: "EMPTY_PRICE" };
  }

  if (typeof price === "string" || price === null) {
    if (price != "" && !isNaN(price))
      return { value: Number(price), reason: "SUCCESS" };

    return { value: firstCover, reason: "MESSAGE" };
  }

  if (typeof price === "number") return { value: price, reason: "SUCCESS" };

  return { value: price, reason: "UNKOWN" };
};

const PriceTextDecider = ({ priceObject, responseid }) => {
  const dispatch = useDispatch();
  let history = useNavigate();
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  if (priceObject.reason === "EMPTY_COVERS") {
    return (
      <NormalText
        text={translations[languagepreference].optionPending}
      ></NormalText>
    );
  }

  if (priceObject.reason === "EMPTY_PRICE")
    return <NormalText text={"-"}></NormalText>;

  if (priceObject.reason === "MESSAGE" || priceObject.reason === "UKNOWN") {
    const key = priceObject.value.toLowerCase();
    const translatedValue =
      translations[languagepreference][key] || priceObject.value;
    return <NormalText text={translatedValue} />;
    // return <NormalText text={priceObject.value}></NormalText>;
  }

  return <Price price={priceObject.value}></Price>;
};
